import React from 'react';
import styles from '../ActionLoader.css';
export default (function (props) {
    if (props === void 0) { props = {}; }
    var fill = props.fill || '#fff';
    var size = props.size || '16';
    return (<div className={styles['action-loader-container']}>
			<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" className={styles['action-loader']}>
				<path fill={fill} fill-rule="evenodd" d="M8.057 14.335a6.335 6.335 0 0 1-5.871-3.886 6.163 6.163 0 0 1-.5-2.465c0-.806.143-1.568.427-2.286a6.428 6.428 0 0 1 1.17-1.918 6.405 6.405 0 0 1 3.94-2.098V0A8.032 8.032 0 0 0 4.38.84a8.052 8.052 0 0 0-2.293 1.748A8.108 8.108 0 0 0 .557 5.037 7.799 7.799 0 0 0 0 7.984c0 1.11.21 2.152.63 3.126.42.974.997 1.823 1.728 2.547a8.2 8.2 0 0 0 2.563 1.714A7.872 7.872 0 0 0 8.057 16c1.005 0 1.96-.174 2.866-.522a8.003 8.003 0 0 0 2.416-1.445A8.034 8.034 0 0 0 16 9.143h-1.687a6.296 6.296 0 0 1-.778 2.057 6.413 6.413 0 0 1-1.392 1.64 6.496 6.496 0 0 1-1.875 1.095c-.699.266-1.436.4-2.21.4z"/>
			</svg>
		</div>);
});
